// Small display formatters shared by the pages. Every one of them renders an
// absent value as an em dash rather than as zero: in this console "the server
// did not report it" and "the real value is zero" must never look the same.

export function usd(n: number | null | undefined): string {
  if (n === null || n === undefined || !Number.isFinite(n)) return '—'
  return n.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
}

/** Small amounts (per-call Anthropic cost) need more than two decimals. */
export function usdFine(n: number | null | undefined): string {
  if (n === null || n === undefined || !Number.isFinite(n)) return '—'
  if (n !== 0 && Math.abs(n) < 0.01) return `$${n.toFixed(4)}`
  return usd(n)
}

export function num(n: number | null | undefined): string {
  if (n === null || n === undefined || !Number.isFinite(n)) return '—'
  return n.toLocaleString('en-US')
}

export function credits(n: number | null | undefined): string {
  if (n === null || n === undefined || !Number.isFinite(n)) return '—'
  const rounded = Math.round(n)
  return `${rounded.toLocaleString('en-US')} ${Math.abs(rounded) === 1 ? 'credit' : 'credits'}`
}

/** Percentage with one decimal. null when the ratio is undefined (zero base). */
export function pct(numerator: number, denominator: number): string {
  if (!denominator) return '—'
  return `${((numerator / denominator) * 100).toFixed(1)}%`
}

/** Margin of billed over cost, as a share of billed. */
export function marginPct(rawCostUsd: number, billedUsd: number): string {
  if (!billedUsd) return '—'
  return `${(((billedUsd - rawCostUsd) / billedUsd) * 100).toFixed(1)}%`
}

/** Accepts unix ms, ISO strings or YYYY-MM-DD; returns YYYY-MM-DD (UTC). */
export function day(v: number | string | null | undefined): string {
  if (v === null || v === undefined || v === '') return '—'
  const d = new Date(v)
  if (Number.isNaN(d.getTime())) return String(v)
  return d.toISOString().slice(0, 10)
}

export function dateTime(v: number | string | null | undefined): string {
  if (v === null || v === undefined || v === '') return '—'
  const d = new Date(v)
  if (Number.isNaN(d.getTime())) return String(v)
  return d.toISOString().slice(0, 16).replace('T', ' ') + ' UTC'
}
